<template>
  <div class="relative w-full mb-3" v-if="testInfo">
    <label
      class="block uppercase text-gray-700 text-xs font-bold mb-2"
      htmlFor="grid-password"
    >
      เลือกแบบทดสอบ:
    </label>
    <v-select
      :options="testInfo"
      v-model="selectedTest"
      @input="mutateSelectedTest"
    >
      <template #search="{ attributes, events }">
        <input
          class="from-control ui-input-text"
          v-bind="attributes"
          v-on="events"
          placeholder=""
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      testInfo: null,
      selectedTest: null,
      userData: this.$cookies.get("user"),
    };
  },
  mounted() {
    //FETCH CENTER DATA
    this.axios
      .get(this.$hostUrl + "php_action/courseAPI.php?txtAction=getCourseDropdown")
      .then((response) => {
        this.testInfo = response.data.mainData;
        //console.log(response.data);
      })
      .finally(() => {});

  },
  methods: {
    mutateSelectedTest() {
      //COMMIT STORE NEW DATA
      this.$store.commit("setSelectedTest", this.selectedTest);
    },
  },
};
</script>
<style scoped>
.ui-input-text {
  border-color: transparent;
}
</style>
